import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { successToast, errorToast } from "../../Utils/toast";
import { useCreateKuldeviMutation } from "../../redux/services/kuldeviService/kuldevi.Services";
import CommonBreadcrumb from '../../common/CommonBreadcrumb';
import { FaPlus } from 'react-icons/fa';
function Addkuldevi() {
    const navigate = useNavigate();
    const [createKuldevi, { isLoading }] = useCreateKuldeviMutation();
    const [formData, setFormData] = useState({
        kuldevi_name: "",
        status: "active",
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    // SUBMIT
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await createKuldevi(formData).unwrap();
            console.log(response);
            successToast("Kuldevi Created Successfully");
            navigate(-1);
        } catch (error) {
            console.log(error);
            errorToast("Failed To Create Kuldevi");
        }
    };

    return (
        <div>
            {/* HEADER */}
           
<CommonBreadcrumb
    title="All Kuldevi"
    breadcrumbs={[
        { label: "Home", link: "/" },
        { label: "All Kuldevi" },
    ]}
    buttonText="Add Kuldevi"
    buttonIcon={<FaPlus className="me-2" />}
    buttonLink="/add-kuldevi"
/>
            {/* FORM */}
            <div className="card">
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <div className="container">
                            <div className="row align-items-end">
                                {/* INPUT */}
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Enter Kuldevi Name</label>
                                        <input
                                            type="text"
                                            className="form-control custumform"
                                            placeholder="Enter Kuldevi Name"
                                            name="kuldevi_name"
                                            value={formData.kuldevi_name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group mt-3">
                                        <label>Status</label>
                                        <select
                                            name="status"
                                            className="form-control"
                                            value={formData.status}
                                            onChange={handleChange}
                                        >
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                    </div>
                                </div>

                                {/* BUTTON */}
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <div className="button_submit">
                                            <button
                                                type="submit"
                                                className="btn btn-primary"
                                                disabled={isLoading}
                                            >
                                                {isLoading ? "Loading..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Addkuldevi;